import React, { useContext } from "react"
import { defineMessage, useIntl } from "react-intl"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { CarrotCardCostSharePreAuthContext } from "../../state/CarrotCardCostSharePreAuthContext"
import { useConvertTranslatedLabel } from "#/services/common-forms/useConvertTranslatedLabel"
import { FormSelectOption } from "@carrotfertility/carotene-core-x"
import { RadioGroupWithTileStep } from "#/components/carrot-card-cost-share/steps/variants/RadioGroupWithTileStep"
import { CarrotRxRequiredBox } from "#/components/carrot-card-cost-share/steps/shared/CarrotRxRequiredBox"

const medicationExpensesOptions = [
  { label: defineMessage({ defaultMessage: "Yes" }), value: "YES" },
  { label: defineMessage({ defaultMessage: "No" }), value: "NO" }
]

export function RelatedToMedicationExpensesFertilityStep(): JSX.Element {
  const intl = useIntl()
  const { send } = useStateMachine()
  const {
    dispatchFormState,
    formState: { isMedicationExpenses },
    serverState: { hasFertilityCareRxCoverage }
  } = useContext(CarrotCardCostSharePreAuthContext)
  const formattedOptions = useConvertTranslatedLabel(medicationExpensesOptions) as FormSelectOption[]

  function onSubmit(formValues: { [key: string]: string }): void {
    dispatchFormState({
      type: "UPDATE_FIELD",
      field: "isMedicationExpenses",
      value: formValues.isMedicationExpenses
    })
    if (formValues.isMedicationExpenses === "YES" && !hasFertilityCareRxCoverage) {
      send("NOT_COVERED")
      return
    }
    send("COVERED")
  }

  return (
    <RadioGroupWithTileStep
      title={intl.formatMessage({ defaultMessage: "Is this related to medication expenses?" })}
      name="isMedicationExpenses"
      options={formattedOptions}
      onSubmit={onSubmit}
      defaultValue={isMedicationExpenses}
    >
      <CarrotRxRequiredBox name="isMedicationExpenses" />
    </RadioGroupWithTileStep>
  )
}
